import Box from "../Box";
import MarkdownRenderer from "../MarkdownRenderer";

type MarkdownTextProps = {
	text: string;
	variant?: "term" | "fact" | "description" | "stem" | "answer" | "explanation";
	fontSize?: number;
	textAlign?: "left" | "auto" | "right" | "center" | "justify" | undefined;
	paragraphMarginVertical?: number;
	style?: Record<string, unknown>;
};

const MarkdownText = ({
	text,
	variant = "explanation",
	fontSize = 14,
	textAlign = "left",
	paragraphMarginVertical = 0,
	style,
}: MarkdownTextProps) => {
	return (
		<Box style={style}>
			<MarkdownRenderer
				text={text}
				variant={variant}
				fontSize={fontSize}
				textAlign={textAlign}
				paragraphMarginVertical={paragraphMarginVertical}
			/>
		</Box>
	);
};

export default MarkdownText;
